import React, { ReactElement } from "react";

import Chip from "@mui/material/Chip";

const AzureChip = ({ text }: { text: string }): ReactElement => {
 return (
  <Chip
   size="small"
   sx={{
    color: "#30D1FF",
    border: "1px solid #30D1FF",
    backgroundColor: "rgba(48, 210, 255, 0.2)",
    fontWeight: "bold"
   }}
   label={text}
  />
 );
};

export default AzureChip;
